import Request from './../../request';

// import props
import { IDataGoodsResourceShortProps } from '../../../props/data/goods';

const DataGoodsService = {
  findSimilar: async (qs?: string): Promise<IDataGoodsResourceShortProps[]> => {
    try {
      const results = await Request.get(`/api/data/goods/find_similar?${qs || ''}`);
      return results;
    } catch (e) {
      throw e;
    }
  }
};

export default DataGoodsService;
